const assignEmployeesBehavior = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const _transientContext$sel = transientContext.selection,
    selection = _transientContext$sel === void 0 ? {} : _transientContext$sel,
    _transientContext$con = transientContext.content.employees,
    employees = _transientContext$con === void 0 ? {} : _transientContext$con;
  const formTypeIdentifiers = Object.keys(selection);
  for (let i = 0; i < formTypeIdentifiers.length; i += 1) {
    const formTypeIdentifier = formTypeIdentifiers[i];
    const formIDs = selection[formTypeIdentifier];
    for (let j = 0; j < formIDs.length; j += 1) {
      // eslint-disable-next-line no-await-in-loop
      await sourceEvaluator({
        type: 'patchContentBehavior',
        id: formIDs[j],
        patches: [{
          assignedEmployees: employees
        }]
      });
    }
  }
  const numEmployees = Object.keys(employees).length;
  const addedString = numEmployees === 1 ? '1 employee' : "".concat(numEmployees, " employees");
  await sourceEvaluator({
    type: 'alertBehavior',
    message: "".concat(addedString, " assigned."),
    options: [{
      title: 'OK'
    }]
  });
};
module.exports = {
  evaluate: assignEmployeesBehavior
};